export default {
  app: {
    featured: 'বিশেষ ভাবে প্রকাশিত',
    random: 'এলোমেলো',
    explore: 'ঘুরে দেখুন',
    keywords: 'কীওয়ার্ড সমূহ',
    search: 'খুঁজে দেখুন',
  },
  explore: {
    filters: 'ফিল্টার',
    resetFilters: 'ফিল্টার রিসেট করুন',
    addKeyword: 'কীওয়ার্ড যোগ করুন',
  },
  recipe: {
    contributedBy: 'অবদান করেছেন',
    ingredients: 'উপকরণ সমূহ',
    directions: 'প্রস্তুত প্রণালি',
    fullRecipe: 'সম্পূর্ণ রেসিপি দেখুন',
    similarDrinks: 'অনুরূপ পানীয়গুলো',
  },
  featuredRecipes: {
    loadMore: 'আরো দেখুন',
  },
  recipeFind: {
    filterBy: 'ফিল্টার করার নির্ণায়কসমুহ',
    name: 'নাম',
    ingredients: 'উপকরণ সামগ্রী',
    keywords: 'কীওয়ার্ড সমূহ',
    searchForIngredients: 'আপনি একটি স্পেস দিয়ে আলাদা করে একাধিক উপাদান অনুসন্ধান করতে পারেন',
    searchForKeywords: 'আপনি একটি স্পেস দিয়ে আলাদা করে একাধিক কীওয়ার্ড অনুসন্ধান করতে পারেন',
  },
  recipeList: {
    viewRecipe: 'রেসিপিটি দেখুন',
  },
  recipeToolbar: {
    print: 'প্রিন্ট',
    share: 'শেয়ার',
    shareOnFacebook: 'ফেসবুকে শেয়ার করুন',
    shareOnTwitter: 'টুইটারে শেয়ার করুন',
    copyURL: 'ইউআরএল অনুলিপি করে নিন',
    hideImage: 'ছবি লুকান',
  },
  favorites: {
    removeAllFavorites: 'সমস্ত প্রিয় সরান',
    noFavoriteDrinks: 'আপনার কোন প্রিয় পানীয় নেই',
    removeFavoritesPrompt: 'আপনি কি নিশ্চিত যে আপনি সমস্ত পছন্দ অপসারণ করতে চান',
    delete: 'মুছুন',
    cancel: 'বাতিল করুন',
  },
  keywordList: {
    enterYourKeyword: 'আপনার কীওয়ার্ড লিখুন',
  },
  search: {
    findYourDrink: 'আপনার পানীয় খুঁজুন',
  },
  pageNotFound: {
    pageNotFound: 'আপনি যে পৃষ্ঠাটি খুঁজছেন তা পাওয়া যায়নি',
    backToHome: 'হোমপেজে ফিরে যান',
  },
};
